// import { gql } from 'apollo-boost'
import { gql } from '@apollo/client'

export const TASK_COUNT_QUERY = gql(
  `
    query HostTasks($userId: Int!) {
        taskCount(userId: $userId)
    }
    `
)
